module.exports = __webpack_public_path__ + "static/media/icon-star-half-solid.8a40da1b.svg";